
import { defineComponent } from '@vue/composition-api';
import { metaData } from '~/configuration/metaData';
import ShopFooterSections from '~/components/shop/ShopFooterSections.vue';
import PackageCard from '~/components/v5/PackageCard.vue';
import FCSwiper from '~/components/FCSwiper.vue';
import packages from '~/data/packages.js';
import fightcampBagRing from '~/data/includes/fightcamp-bag-ring.js';
import { windowMatchMediaMixin } from '~/mixins/matchMedia';
import { transformPackageProduct } from '~/utils/transformers';

export default defineComponent({
  name: 'Shop',
  mixins: [windowMatchMediaMixin],
  components: {
    PackageCard,
    ShopFooterSections,
    FCSwiper,
  },

  head: {
    ...metaData.shop,
  },
  mounted() {
  },
  computed: {
    packages() {
      const isCanada = this.$store.getters.isGeoLocatedCanada;

      return packages.map((pkg, index) => {
        const transformedPkg = transformPackageProduct({
          cmsContent: pkg,
          eCommContent: this.$store.getters.productsCollection,
        });

        // Add bag ring to Core package for Canadian customers
        if (isCanada && index === 1 && pkg.title === 'Core') {
          transformedPkg.includedProducts = [
            ...transformedPkg.includedProducts,
            fightcampBagRing,
          ];

          transformedPkg.assets = [
            {
              src: 'https://a.storyblok.com/f/152150/1200x1120/9e899fdccd/core_package_ring.jpg',
              alt: 'FightCamp Core Package with Ring',
            },
          ];
        }

        return transformedPkg;
      });
    },
    isMobile(): boolean {
      return this.mixinMatchMedia.isMobile;
    },
  },
  methods: {
    getNameColor(name: string): string {
      const nameColorMap: Record<string, string> = {
        Connect: 'package-card__title--gray',
        Core: 'package-card__title--navy',
        Elite: 'package-card__title--red',
      };
      return nameColorMap[name] || '';
    },
    getPackageIncludes(packageTitle: string, packageIncludes: any[]) {
      if (packageTitle === 'Connect') {
        return packageIncludes.map((item) => ({
          text: item.productName,
          isInheritedText: false,
          icon: 'check-circle',
        }));
      }

      if (packageTitle === 'Core') {
        const connectItems = packages[0].includes.length;
        const additionalItems = packageIncludes.slice(connectItems);

        return [
          { text: 'Everything from FightCamp Connect', isInheritedText: true, icon: 'check-circle' },
          ...additionalItems.map((item) => ({
            text: item.productName,
            isInheritedText: false,
            icon: 'plus-circle',
          })),
        ];
      }

      if (packageTitle === 'Elite') {
        const coreItems = packages[1].includes.length;
        const additionalItems = packageIncludes.slice(coreItems);

        return [
          { text: 'Everything from FightCamp Connect & Core', isInheritedText: true, icon: 'check-circle' },
          ...additionalItems.map((item) => ({
            text: item.productName,
            isInheritedText: false,
            icon: 'plus-circle',
          })),
        ];
      }

      return packageIncludes.map((item) => ({
        text: item.productName,
        isInheritedText: false,
        icon: 'check-circle',
      }));
    },
  },
});
